import React, { Component } from 'react';
import { withTranslation, Translation, } from 'react-i18next';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import { View, ActivityIndicator} from "react-native-web";

/*import HeaderPC from '../../header/HeaderPC';
import HeaderMobile from '../../header/HeaderMobile';
import HeaderTablet from '../../header/HeaderTablet';*/

const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function LoadingPage() {




    return (

	         <div>


                  {!isMobileOnly && !isTablet &&
                    <BrowserView>
                      <View style={{width:viewportWidth, height: viewportHeight, justifyContent: 'center', alignSelf: 'center', backgroundColor: '#181f2a'}}>




                        <View><ActivityIndicator  animating={true} color="#8996a6" /></View>

                          <View><div style={{clear:'both', height: '50px'}}></div></View>

                          <View><div style={{width: '400px', margin: 'auto', textAlign: 'center'}}><img src={'https://d3van47cb9u9tj.cloudfront.net/rerdc/reRDC_logo.png'} style={{width: '400px'}}/></div></View>


                      </View>
                   </BrowserView>
                 }



                 {isMobileOnly &&
           			  <MobileView>
                    <View style={{width:viewportWidth, height: viewportHeight, justifyContent: 'center', alignSelf: 'center', backgroundColor: '#181f2a'}}>




                      <View><ActivityIndicator  animating={true} color="#8996a6" /></View>

                        <View><div style={{clear:'both', height: '50px'}}></div></View>

                        <View><div style={{width: '60%', margin: 'auto', textAlign: 'center'}}><img src={'https://d3van47cb9u9tj.cloudfront.net/rerdc/reRDC_logo.png'} style={{width: '100%'}}/></div></View>



                    </View>
           			 </MobileView>
           			}

           			{isTablet &&
           			  <TabletView>
                      <View style={{width:viewportWidth, height: viewportHeight, justifyContent: 'center', alignSelf: 'center', backgroundColor: '#181f2a'}}>




                        <View><ActivityIndicator  animating={true} color="#8996a6" /></View>

                          <View><div style={{clear:'both', height: '50px'}}></div></View>

                          <View><div style={{width: '400px', margin: 'auto', textAlign: 'center'}}><img src={'https://d3van47cb9u9tj.cloudfront.net/rerdc/reRDC_logo.png'} style={{width: '400px'}}/></div></View>



                      </View>
           			  </TabletView>
           			}








	        </div>

    )

}
